import React from 'react'
import { Navigate } from 'react-router-dom'

import Public from '../../pages/_layouts/Public'
import { useAuthStore } from '../../store/auth'

export interface AuthRouteProps {
  Component: React.FunctionComponent
}

const AuthRoute: React.FunctionComponent<AuthRouteProps> = ({ Component }) => {
  const { signed } = useAuthStore((state) => state)

  return <Public>{!signed ? <Component /> : <Navigate to='/' />}</Public>
}

export default AuthRoute
